module.exports = __webpack_public_path__ + "static/img/wx-code.8ce55db.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/wx-code.png
// module id = bXq9
// module chunks = 62